<template>
	<div class="form__group">
		<multiselect
            :options="options"
            :placeholder="placeholder"
            :allow-empty="allowEmpty"
            label="label"
            track-by="id"
            :multiple="multiple"
            :searchable="false"
            :show-labels="false"
            v-model="selected"
            :class="{
                'form__control': true,
                'form__control--invalid': errors.first(this.name)
            }"
        />
		<label class="form__label">Deal Type</label>
        <a
            href="#"
            @click.prevent.stop="clearValue"
            class="form__clear"
            v-if="this.selected || (this.selected && this.selected.length > 0)"
        >
            Clear
        </a>
		<div class="form__validation">{{ errors.first(this.name) }}</div>
	</div>
</template>

<script>
	import Select from './Select';

	export default {
		name: 'FormControlDealType',
		mixins: [Select],
		data() {
			let options = [
				{
					label: 'Company Sale',
					id: 1,
				},
				{
					label: 'Acquisition',
					id: 2,
				},
				{
					label: 'IPO',
					id: 4,
				},
				{
					label: 'Buy out',
					id: 5,
				},
				{
					label: 'Debt-restructuring',
					id: 6,
				},
				{
					label: 'Valuation',
					id: 9,
				},
				{
					label: 'Fundraising',
					id: 10,
				},
                {
                    label: 'Debt-advisory',
                    id: 11,
                }
			];

			return {
				options,
			}
		},
	}
</script>

